export const collectionsData = {
  "bijoux-souvenir-avec-poils": {
    name: "Bijoux souvenir avec poils",
    slug: "bijoux-souvenir-avec-poils",
    prefix: "SP",
    description: "Gardez un souvenir éternel de votre compagnon avec nos bijoux en résine intégrant les poils de votre animal. Chaque pièce est unique et fabriquée avec soin.",
    price: "30 $",
    image: "https://images.unsplash.com/photo-1761325684394-f5adbdf271e5?w=600&q=80",
    products: [
      {
        ref: "SP01",
        name: "Pendentif Coeur avec poils",
        price: "30 $",
        image: "https://images.unsplash.com/photo-1632212782195-4dad1dc3144c?w=500&q=80",
        desc: "Un pendentif en forme de coeur avec les poils de votre compagnon intégrés dans la résine.",
      },
      {
        ref: "SP02",
        name: "Médaillon Rond souvenir",
        price: "30 $",
        image: "https://images.unsplash.com/photo-1588942458058-55beb017132c?w=500&q=80",
        desc: "Médaillon rond en résine avec inclusion de poils et paillettes au choix.",
      },
      {
        ref: "SP03",
        name: "Pendentif Patte de chat",
        price: "30 $",
        image: "https://images.unsplash.com/photo-1633796059404-c65239b5516c?w=500&q=80",
        desc: "Forme de patte de chat en résine avec les poils de votre félin.",
      },
      {
        ref: "SP04",
        name: "Pendentif Étoile souvenir",
        price: "30 $",
        image: "https://images.pexels.com/photos/4741620/pexels-photo-4741620.jpeg?auto=compress&cs=tinysrgb&w=500",
        desc: "Étoile en résine avec poils et brillants pour un souvenir lumineux.",
      },
    ],
  },
  "boucles-d-oreilles": {
    name: "Boucles d'oreilles",
    slug: "boucles-d-oreilles",
    prefix: "BD",
    description: "Des boucles d'oreilles en résine élégantes et raffinées. Disponibles dans une variété de styles et de couleurs pour s'adapter à tous les goûts.",
    price: "8 $ à 30 $",
    image: "https://images.pexels.com/photos/6070242/pexels-photo-6070242.jpeg?auto=compress&cs=tinysrgb&w=600",
    products: [
      {
        ref: "BD01",
        name: "Puces rondes classiques",
        price: "8 $",
        image: "https://images.unsplash.com/photo-1707222609449-89d5b768b?w=500&q=80",
        desc: "Petites puces rondes en résine colorée. Légères et confortables.",
      },
      {
        ref: "BD02",
        name: "Pendantes goutte",
        price: "15 $",
        image: "https://images.pexels.com/photos/6070242/pexels-photo-6070242.jpeg?auto=compress&cs=tinysrgb&w=500",
        desc: "Boucles pendantes en forme de goutte avec paillettes intégrées.",
      },
      {
        ref: "BD03",
        name: "Créoles en résine",
        price: "20 $",
        image: "https://images.unsplash.com/photo-1721808086755-7bb2b92b7d1c?w=500&q=80",
        desc: "Créoles modernes avec incrustations de résine colorée.",
      },
      {
        ref: "BD04",
        name: "Pendantes avec poils",
        price: "30 $",
        image: "https://images.unsplash.com/photo-1622993361118-b6365d859ab6?w=500&q=80",
        desc: "Boucles pendantes avec inclusion des poils de votre animal.",
      },
    ],
  },
  breloques: {
    name: "Breloques",
    slug: "breloques",
    prefix: "B",
    description: "De petites breloques en résine à accrocher partout : bracelets, sacs, fermetures éclair. Un bijou discret mais plein de sens.",
    price: "5 $ à 10 $",
    image: "https://images.unsplash.com/photo-1766560359180-96dd82ce5cb6?w=600&q=80",
    products: [
      {
        ref: "B01",
        name: "Breloque Coeur mini",
        price: "5 $",
        image: "https://images.unsplash.com/photo-1766560359503-dc05c91109f2?w=500&q=80",
        desc: "Mini breloque en forme de coeur en résine. Parfaite pour bracelet.",
      },
      {
        ref: "B02",
        name: "Breloque Étoile",
        price: "5 $",
        image: "https://images.unsplash.com/photo-1766560360108-954ec9b4b88e?w=500&q=80",
        desc: "Petite étoile en résine avec paillettes. Légère et colorée.",
      },
      {
        ref: "B03",
        name: "Breloque Patte",
        price: "8 $",
        image: "https://images.unsplash.com/photo-1723144290281-de6d80a79028?w=500&q=80",
        desc: "Forme de patte d'animal en résine avec couleurs personnalisables.",
      },
      {
        ref: "B04",
        name: "Breloque Lune",
        price: "10 $",
        image: "https://images.pexels.com/photos/4741705/pexels-photo-4741705.jpeg?auto=compress&cs=tinysrgb&w=500",
        desc: "Breloque en forme de lune avec brillants et résine transparente.",
      },
    ],
  },
  colliers: {
    name: "Colliers",
    slug: "colliers",
    prefix: "C",
    description: "Nos colliers en résine se portent près du coeur. Chaîne délicate et pendentif personnalisé selon vos envies.",
    price: "20 $",
    image: "https://images.unsplash.com/photo-1632212782195-4dad1dc3144c?w=600&q=80",
    products: [
      {
        ref: "C01",
        name: "Collier Coeur en résine",
        price: "20 $",
        image: "https://images.unsplash.com/photo-1632212782195-4dad1dc3144c?w=500&q=80",
        desc: "Pendentif coeur en résine sur chaîne argentée. Personnalisable.",
      },
      {
        ref: "C02",
        name: "Collier Rond Galaxy",
        price: "20 $",
        image: "https://images.pexels.com/photos/4741620/pexels-photo-4741620.jpeg?auto=compress&cs=tinysrgb&w=500",
        desc: "Pendentif rond avec effet galaxie en résine et paillettes.",
      },
      {
        ref: "C03",
        name: "Collier Goutte Florale",
        price: "20 $",
        image: "https://images.unsplash.com/photo-1622993361118-b6365d859ab6?w=500&q=80",
        desc: "Forme de goutte avec inclusion de petites fleurs séchées.",
      },
      {
        ref: "C04",
        name: "Collier Médaillon Patte",
        price: "20 $",
        image: "https://images.unsplash.com/photo-1633796059404-c65239b5516c?w=500&q=80",
        desc: "Médaillon avec empreinte de patte en résine. Souvenir tendre.",
      },
    ],
  },
  medailles: {
    name: "Médailles",
    slug: "medailles",
    prefix: "M",
    description: "Des médailles en résine pour commémorer vos moments précieux. Chaque médaille peut intégrer photos, poils ou éléments personnels.",
    price: "20 $",
    image: "https://images.unsplash.com/photo-1771660722417-38ceb9e85bc1?w=600&q=80",
    products: [
      {
        ref: "M01",
        name: "Médaille Ronde classique",
        price: "20 $",
        image: "https://images.pexels.com/photos/35875107/pexels-photo-35875107.jpeg?auto=compress&cs=tinysrgb&w=500",
        desc: "Médaille ronde en résine avec possibilité d'inclusion photo.",
      },
      {
        ref: "M02",
        name: "Médaille Coeur souvenir",
        price: "20 $",
        image: "https://images.unsplash.com/photo-1588942458058-55beb017132c?w=500&q=80",
        desc: "Médaille en forme de coeur, idéale pour un souvenir d'animal.",
      },
      {
        ref: "M03",
        name: "Médaille Ovale fleurie",
        price: "20 $",
        image: "https://images.pexels.com/photos/35875110/pexels-photo-35875110.jpeg?auto=compress&cs=tinysrgb&w=500",
        desc: "Médaille ovale avec fleurs séchées et résine cristalline.",
      },
      {
        ref: "M04",
        name: "Médaille Étoile brillante",
        price: "20 $",
        image: "https://images.pexels.com/photos/4741705/pexels-photo-4741705.jpeg?auto=compress&cs=tinysrgb&w=500",
        desc: "Médaille en forme d'étoile avec paillettes et brillants.",
      },
    ],
  },
  noel: {
    name: "Noël",
    slug: "noel",
    prefix: "N",
    description: "Des créations festives en résine pour les fêtes de fin d'année. Ornements scintillants avec portraits d'animaux en tenue de Noël, parfaits pour décorer votre sapin ou offrir en cadeau.",
    price: "Dès 5 $",
    image: "/images/noel/noel-teckel-cadeaux.webp",
    products: [
      {
        ref: "N01",
        name: "Ornement Teckel et cadeaux",
        price: "10 $",
        image: "/images/noel/noel-teckel-cadeaux.webp",
        desc: "Ornement rond en résine rouge scintillante avec un adorable teckel entouré de cadeaux de Noël. Paillettes dorées et effet neige.",
      },
      {
        ref: "N02",
        name: "Ornement Chihuahua écharpe",
        price: "10 $",
        image: "/images/noel/noel-chihuahua-echarpe.webp",
        desc: "Médaillon en résine rouge pailletée avec un chihuahua portant une écharpe tricotée et tenant une baguette magique étoilée.",
      },
      {
        ref: "N03",
        name: "Ornement Beagle Père Noël",
        price: "10 $",
        image: "/images/noel/noel-beagle-pere-noel.webp",
        desc: "Porte-clés en résine bleu nuit scintillant avec un beagle en costume de Père Noël entouré de cadeaux festifs.",
      },
      {
        ref: "N04",
        name: "Ornement Beagle tuque",
        price: "10 $",
        image: "/images/noel/noel-beagle-tuque.webp",
        desc: "Pendentif rond en résine bleu étoilé avec un beagle coiffé d'une tuque verte et d'une chemise à carreaux des fêtes.",
      },
      {
        ref: "N05",
        name: "Ornement Corgi costume",
        price: "10 $",
        image: "/images/noel/noel-corgi-costume.webp",
        desc: "Porte-clés en résine bleu foncé pailletée avec un corgi en costume du Père Noël, entouré de paquets cadeaux.",
      },
      {
        ref: "N06",
        name: "Ornement Chaton renne",
        price: "10 $",
        image: "/images/noel/noel-chaton-renne.webp",
        desc: "Porte-clés en résine bleu étoilé avec un chaton tabby portant des bois de renne rouges et une écharpe tricotée.",
      },
      {
        ref: "N07",
        name: "Ornement Chaton écharpe verte",
        price: "10 $",
        image: "/images/noel/noel-chaton-echarpe-verte.webp",
        desc: "Ornement en résine rouge pailletée avec un chaton emmitouflé dans une écharpe verte ornée d'une étoile dorée.",
      },
      {
        ref: "N08",
        name: "Ornement Chaton Père Noël",
        price: "10 $",
        image: "/images/noel/noel-chaton-pere-noel.webp",
        desc: "Ornement en résine rouge scintillante avec un chaton tabby coiffé d'un bonnet de Père Noël. Ambiance festive.",
      },
      {
        ref: "N09",
        name: "Ornement Chat couronné de houx",
        price: "10 $",
        image: "/images/noel/noel-chat-houx.webp",
        desc: "Ornement en résine rouge profond avec un chat aux yeux bleus entouré de branches de houx et de baies rouges.",
      },
      {
        ref: "N10",
        name: "Ornement Chat tuque bleue",
        price: "10 $",
        image: "/images/noel/noel-chat-tuque-bleue.webp",
        desc: "Ornement en résine rouge pailletée avec un chat portant une tuque bleue à pompon, entouré de houx et de baies.",
      },
      {
        ref: "N11",
        name: "Ornement Chaton bonnet de Noël",
        price: "10 $",
        image: "/images/noel/noel-chaton-bonnet-noel.webp",
        desc: "Ornement en résine rouge scintillante avec un chaton tabby portant un bonnet de Père Noël et un noeud papillon rouge à grelots dorés.",
      },
      {
        ref: "N12",
        name: "Ornement Chaton bois de renne",
        price: "10 $",
        image: "/images/noel/noel-chaton-bois-renne.webp",
        desc: "Ornement en résine rouge pailletée avec un chaton roux portant un serre-tête bois de renne rouges et une écharpe tricotée assortie.",
      },
      {
        ref: "N13",
        name: "Breloque Renne en résine",
        price: "8 $",
        image: "/images/noel/noel-renne-resine.webp",
        desc: "Breloque en forme de renne en résine rouge translucide pailletée argent et rose. Attache dorée, parfaite pour décorer le sapin.",
      },
      {
        ref: "N14",
        name: "Breloque Pingouin en résine",
        price: "8 $",
        image: "/images/noel/noel-pingouin-resine.webp",
        desc: "Breloque en forme de pingouin en résine rouge pailletée argent et rose. Petite décoration festive au look adorable.",
      },
      {
        ref: "N15",
        name: "Breloque Sapin en résine",
        price: "8 $",
        image: "/images/noel/noel-sapin-resine.webp",
        desc: "Breloque en forme de sapin de Noël en résine scintillante. Attache dorée, idéale comme ornement ou porte-clés festif.",
      },
      {
        ref: "N16",
        name: "Ornement Beagle couronne hivernale",
        price: "8 $",
        image: "/images/noel/noel-beagle-hiver.jpeg",
        desc: "Ornement rond en résine pailletée avec un adorable beagle entouré de feuillage, cocottes et petites touches festives pour une ambiance douce et hivernale.",
      },
    ],
  },
  "porte-cles": {
    name: "Porte-clés",
    slug: "porte-cles",
    prefix: "PC",
    description: "Gardez votre compagnon toujours avec vous grâce à nos porte-clés en résine. Robustes et élégants, ils s'emportent partout.",
    price: "15 $ à 20 $",
    image: "https://images.pexels.com/photos/6559610/pexels-photo-6559610.jpeg?auto=compress&cs=tinysrgb&w=600",
    products: [
      {
        ref: "PC01",
        name: "Porte-clés Rond",
        price: "15 $",
        image: "https://images.unsplash.com/photo-1633796059404-c65239b5516c?w=500&q=80",
        desc: "Porte-clés rond en résine avec anneau métallique robuste.",
      },
      {
        ref: "PC02",
        name: "Porte-clés Coeur",
        price: "15 $",
        image: "https://images.unsplash.com/photo-1632212782195-4dad1dc3144c?w=500&q=80",
        desc: "Porte-clés en forme de coeur. Couleurs personnalisables.",
      },
      {
        ref: "PC03",
        name: "Porte-clés Patte",
        price: "18 $",
        image: "https://images.unsplash.com/photo-1761325684394-f5adbdf271e5?w=500&q=80",
        desc: "Forme de patte d'animal en résine avec options de personnalisation.",
      },
      {
        ref: "PC04",
        name: "Porte-clés Souvenir avec poils",
        price: "20 $",
        image: "https://images.pexels.com/photos/4741620/pexels-photo-4741620.jpeg?auto=compress&cs=tinysrgb&w=500",
        desc: "Porte-clés en résine avec inclusion des poils de votre animal.",
      },
    ],
  },
};

export const collectionsList = [
  { name: "Bijoux souvenir avec poils", slug: "bijoux-souvenir-avec-poils", price: "30 $", image: collectionsData["bijoux-souvenir-avec-poils"].image, desc: "Un souvenir éternel avec les poils de votre compagnon." },
  { name: "Boucles d'oreilles", slug: "boucles-d-oreilles", price: "8 $ à 30 $", image: collectionsData["boucles-d-oreilles"].image, desc: "Élégance et raffinement pour vos oreilles." },
  { name: "Breloques", slug: "breloques", price: "5 $ à 10 $", image: collectionsData["breloques"].image, desc: "Petits bijoux pleins de charme à accrocher partout." },
  { name: "Colliers", slug: "colliers", price: "20 $", image: collectionsData["colliers"].image, desc: "Portez votre amour près du coeur." },
  { name: "Médailles", slug: "medailles", price: "20 $", image: collectionsData["medailles"].image, desc: "Une médaille personnalisée pour un souvenir éternel." },
  { name: "Noël", slug: "noel", price: "Dès 5 $", image: "/images/noel/noel-teckel-cadeaux.webp", desc: "Des créations festives pour les fêtes." },
  { name: "Porte-clés", slug: "porte-cles", price: "15 $ à 20 $", image: collectionsData["porte-cles"].image, desc: "Gardez votre compagnon toujours avec vous." },
];
